/**
 * OceanSurfaceBg — 海面光影层
 * 极慢 CSS 动画，用户感觉"海在动"
 */
export default function OceanSurfaceBg() {
  return (
    <div className="absolute inset-x-0 bottom-0 h-[50%] overflow-hidden" style={{ pointerEvents: 'none' }}>
      <div
        className="absolute inset-0"
        style={{
          background: [
            'linear-gradient(180deg,',
            'rgba(6, 24, 42, 0) 0%,',
            'rgba(10, 40, 70, 0.05) 30%,',
            'rgba(15, 55, 95, 0.08) 60%,',
            'rgba(8, 29, 50, 0.15) 100%)',
          ].join(''),
          animation: 'ocean-shimmer 14s ease-in-out infinite',
        }}
      >
        <div
          className="absolute top-0 left-[15%] w-[45%] h-[60%]"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(88, 183, 232, 0.06) 0%, transparent 70%)',
            animation: 'ocean-light-drift 18s ease-in-out infinite',
          }}
        />
        <div
          className="absolute top-[15%] left-[50%] w-[30%] h-[40%]"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(242, 200, 100, 0.03) 0%, transparent 70%)',
            animation: 'ocean-light-drift 22s ease-in-out infinite reverse',
          }}
        />
      </div>
      <style>{`
        @keyframes ocean-shimmer {
          0%, 100% { opacity: 0.9; transform: translateX(0); }
          50% { opacity: 1; transform: translateX(8px); }
        }
        @keyframes ocean-light-drift {
          0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.7; }
          33% { transform: translate(15px, -8px) scale(1.1); opacity: 1; }
          66% { transform: translate(-10px, 5px) scale(0.95); opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}
